import { QueryResultsAre, Question } from '@jupiterone/jupiter-types';

export const populateQuestionQueriesResultsAreField = (question: Question) => {
  const questionCopy = JSON.parse(JSON.stringify(question)) as Question;

  // populate results are w/ queryResultsAre
  const queries = questionCopy.queries.map((q) => {
    if (q.resultsAre) return q;

    let resultsAre: QueryResultsAre = QueryResultsAre.INFORMATIVE;
    switch (q.name?.toLowerCase()) {
      case 'good':
        resultsAre = QueryResultsAre.GOOD;
        break;
      case 'bad':
        resultsAre = QueryResultsAre.BAD;
        break;
      case 'unknown':
        resultsAre = QueryResultsAre.UNKNOWN;
        break;
      default:
        resultsAre = QueryResultsAre.INFORMATIVE;
        break;
    }
    return { ...q, resultsAre };
  });

  return { ...questionCopy, queries };
};
